import { PageType } from 'Shared/State';
import { componentNames } from 'Shared/component-registry';
import LoginPageViewModel from './LoginPageViewModel.type';

type LoginPageType = LoginPageViewModel & PageType;

export default (currentPage: PageType): currentPage is LoginPageType => {
  return currentPage.componentName === componentNames.Avensia_Common_Features_Account_Login_LoginPageViewModel;
};
